module.exports = __webpack_public_path__ + "img/title.1da91ad5.png";